import {
  Washer1,
  Washer2,
  Washer3,
  Washer4,
  Washer5,
} from "./Products";

export const BannerAirConditionDescription = {
  en: [
    `With rising temperatures and the constant search for effective cooling solutions, <a target="_blank" style="color: blue; text-decoration: underline;" href="https://www.almanea.sa/air-conditioners-c-535/split-acs-c-539"> split air
  conditioners </a> are emerging as an ideal choice for many homes and offices in the Kingdom of
  Saudi Arabia. These air conditioners are quiet, highly energy efficient, and easy to install
  compared to traditional systems, making them the first choice for many.`,
    `In this guide, we review the split air conditioner offers available at Almanea, with a focus on
  providing a variety of types and brands that meet the needs and requirements of each
  customer. We cover everything from small units ideal for small rooms to larger systems
  designed to cool large areas, through a wide range of well-known brands such as LG,
  Samsung, Gree, and many more.`,
    `Split air conditioners are distinguished by their ability to provide a comfortable and refreshing
  environment inside your home or office without the need to install a complex and expensive
  central cooling system. With our split air conditioners in installments, we offer our customers
  the opportunity to obtain the best cooling systems with flexible payment options that allow
  you to enjoy coolness and comfort now and pay later.`,
    `At Almanea, we are proud to offer the best range of split air conditioners in Saudi Arabia, as
  we guarantee our customers access to high-quality products at competitive split air
  conditioner prices. We offer a wide range of payment options, including cash and installment
  purchases, to ensure every customer gets the comfort and convenience they deserve in the
  easiest way possible.`,
    `Get ready to welcome summer in the best possible way with a selection of split air
  conditioners that give you effectiveness, efficiency, and energy economy. Whether you are
  looking for a cooling solution for your bedroom, living room, or even your office, Al Manea is
  your first destination to find what you need. Enjoy a cooler and more comfortable summer
  with our diverse options and flexible payment plans.`,
  ],
  ar: [
    `مع ارتفاع درجات الحرارة والبحث المستمر عن حلول تبريد فعّالة، تبرز <a target="_blank" style="color: blue; text-decoration: underline;" href="https://www.almanea.sa/air-conditioners-c-535/split-acs-c-539">مكيفات سبليت </a> كخيار مثالي للعديد من المنازل والمكاتب في المملكة العربية السعودية. تتميز هذه المكيفات بكونها هادئة، ذات كفاءة عالية في استهلاك الطاقة، وسهولة في التركيب مقارنةً بالأنظمة التقليدية، ما يجعلها الاختيار الأول للكثيرين.`,
    `في هذا الدليل، نستعرض عروض مكيفات سبليت المتوفرة لدى المنيع، مع التركيز على تقديم مجموعة متنوعة من الأنواع والماركات التي تلبي احتياجات ومتطلبات كل عميل. سنغطي كل شيء بدءًا من الوحدات الصغيرة المثالية للغرف الصغيرة وصولًا إلى الأنظمة الأكبر حجمًا المصممة لتبريد مساحات واسعة، مرورًا بمجموعة واسعة من الماركات المعروفة مثل ال جي، سامسونج، جري، وغيرها الكثير.`,
    `تتميز مكيفات سبليت بقدرتها على توفير بيئة مريحة ومنعشة داخل منزلك أو مكتبك دون الحاجة إلى تركيب نظام تبريد مركزي معقد ومكلف. ومع مكيفات سبليت اقساط المتوفرة لدينا في المنيع، نقدم لعملائنا فرصة الحصول على أفضل أنظمة التبريد مع خيارات دفع مرنة تتيح لكم التمتع بالبرودة والراحة الآن والدفع لاحقًا.`,
    `في المنيع، نفخر بتقديمنا لأفضل مجموعة من المكيفات سبليت في السعودية، حيث نضمن لعملائنا الحصول على منتجات عالية الجودة باسعار مكيفات سبليت تنافسية. نحن نقدم مجموعة واسعة من خيارات الدفع، بما في ذلك الدفع نقدًا والشراء بنظام الأقساط، لضمان حصول كل عميل على الراحة والبرودة التي يستحقها بأسهل الطرق الممكنة.`,
    `استعد لاستقبال الصيف بأفضل حال مع مجموعة مختارة من مكيفات سبليت التي تمنحك الفعالية، الكفاءة، والاقتصاد في استهلاك الطاقة. سواء كنت تبحث عن حل تبريد لغرفة نومك، غرفة المعيشة، أو حتى مكتبك، فإن المنيع هو وجهتك الأولى للعثور على ما تحتاجه. استمتع بصيف أكثر برودة وراحة مع خياراتنا المتنوعة وخطط الدفع المرنة التي نقدمها لك.`,
  ],
};

export const BannerDishWasherDescription = {
  en: [
    `Are you searching for the perfect dishwasher that meets your needs and makes your life easier?
    The answer lies in choosing the right dishwasher that fits your lifestyle and kitchen space.
    Whether you prefer a specific size or brand, Almanea offers a wide range of dishwashers to
    choose from.`,
    `In this guide, we will take you on a comprehensive tour to discover the best dishwashers
    available in Saudi Arabia, focusing on sizes, popular brands, and the unique features of each
    model. Our selection caters to all needs, whether you prefer a small, compact dishwasher or a
    larger model that can handle a large number of dishes.`,
    `Almanea provides high-quality dishwashers at competitive prices to its customers in Saudi
    Arabia, ensuring that every customer can find the dishwasher that suits their needs and budget.
    To make your purchase easier, we offer flexible payment options, including installment plans
    that allow you to get your ideal dishwasher now and pay later.`,
    `Enjoy a clutter-free kitchen and sparkling clean dishes by choosing the right dishwasher from
    Almanea, where quality and efficiency meet to offer you the best.`,
  ],
  ar: [
    `هل تبحث عن غساله صحون مثالية تلائم احتياجاتك وتجعل حياتك أسهل؟ الجواب يكمن في اختيار الجلاية المناسبة التي تتماشى مع نمط حياتك ومساحة مطبخك. سواء كنت تفضل غساله مواعين بحجم معين، أو تبحث عن ماركة محددة، فإن المنيع يوفر لك تشكيلة واسعة من انواع غسالات الصحون لتختار منها ما يناسبك.`,
    `في هذا الدليل، سنأخذك في جولة شاملة لاكتشاف أفضل جلاية صحون متوفرة في المملكة العربية السعودية، مع التركيز على احجام غسالة الصحون، الماركات المعروفة، والميزات التي تجعل كل جهاز فريدًا من نوعه. ستجد لدينا مجموعة متنوعة تلبي كافة احتياجاتك، سواء كنت تفضل غسالة صحون صغيرة ومدمجة أو نموذجًا أكبر حجمًا يتسع لأعداد كبيرة من الأواني والصحون.`,
    `المنيع تقدم لعملائها في المملكة العربية السعودية مجموعة واسعة من غسالات مواعين ذات جودة عالية وبأسعار تنافسية، مؤكدين على أن كل عميل يستطيع العثور على الجلاية التي تناسب احتياجاته وميزانيته. ولتسهيل عملية الشراء، نوفر خيارات دفع مرنة، بما في ذلك خطط الدفع بالتقسيط التي تتيح لكم الحصول على غساله الصحون المثالية الآن، والدفع لاحقًا.`,
    `استمتعوا بتجربة مطبخ خالٍ من الفوضى وأواني نظيفة ولامعة بفضل اختياركم الصحيح لغسالة الصحون من المنيع، حيث الجودة والكفاءة تلتقيان لتقديم الأفضل لكم.`,
  ],
};

export const InfoAirConditions = [
  {
    "title-en": "The best split air conditioners with a power of 18,000 BTU",
    "title-ar": "أفضل مكيفات سبليت بقوة 18000 وحدة",
    "description-en": `18 unit split air conditioners are the ideal choice for anyone looking for effective cooling for
    medium-sized spaces. With their advanced design and high energy efficiency, these air
    conditioners provide outstanding performance while maintaining a comfortable and
    refreshing home environment. Whether you want to cool your living room, office, or
    bedroom, you will find in this selection of Almanea that is sure to meet your needs.`,
    "description-ar":
      "تعتبر مكيفات سبليت 18 وحدة الخيار الأمثل لمن يبحث عن تبريد فعّال لمساحات متوسطة الحجم. بفضل تصميمها المتطور وكفاءتها العالية في استهلاك الطاقة، توفر هذه المكيفات أداءً متميزًا مع الحفاظ على بيئة منزلية مريحة ومنعشة. سواء كنت ترغب في تبريد غرفة الجلوس، المكتب، أو غرفة النوم، ستجد في هذه القائمة المختارة من المنيع ما يلبي احتياجاتك بكل تأكيد.",
    q_a: [
      {
        question_en: "Haam Split AC,18300 BTU Cold, HM18CSM23GO",
        question_ar: "مكيف هام جداري الذهبي  18300 بارد ريش ذهبية  HM18CSM23GO",
        answer_en: `The Haam Wall Gold Air Conditioner is one of the best options for large spaces, as it
        combines advanced technology and energy efficiency. It is ideal for homes and offices, with
        a four-way air distribution system that ensures even coverage in every corner of the room.
        The air conditioner&#39;s golden fins enhance its durability and help protect the unit from
        corrosion, extending its lifespan and maintaining its efficiency for a longer period.`,
        answer_ar:
          "يتميز مكيف هام جداري الذهبي بكونه من أفضل الخيارات للمساحات الواسعة، حيث يجمع بين التقنية المتطورة والكفاءة في استهلاك الطاقة. يعتبر مثاليًا للمنازل والمكاتب، مع نظام توزيع هواء رباعي الاتجاهات يضمن تغطية متساوية في كل زاوية من الغرفة. الريش الذهبية للمكيف تعزز من متانته وتساعد على حماية الوحدة من التآكل، مما يطيل من عمرها الافتراضي ويحافظ على كفاءتها لفترة أطول.",
      },
      {
        question_en:
          "MTC Split AC, 18,000 cold, quadruple distribution, MTC18CT24",
        question_ar: "مكيف MTC جداري 18000 بارد توزيع رباعي MTC18CT24",
        answer_en: `This air conditioner from MTC provides powerful and reliable cooling thanks to its 18,000
        BTU capacity. It is easy to install and operate. It comes with advanced features such as
        smart remote control, allowing you to easily adjust the temperature from anywhere in the
        room. Its elegant design makes it a perfect addition to any interior decor, while ensuring
        efficient and fast cooling.`,
        answer_ar:
          "هذا المكيف من ام تي سي يوفر تبريدًا قويًا وموثوقًا بفضل وحدته التي تبلغ 18000 وحدة. يتميز بسهولة التركيب والتشغيل، ويأتي مع ميزات متقدمة مثل التحكم الذكي عن بعد، ما يسمح لك بتعديل درجة الحرارة بسهولة من أي مكان في الغرفة. تصميمه الأنيق يجعله إضافة مثالية لأي ديكور داخلي، مع ضمان تبريد فعّال وسريع.",
      },
      {
        question_en:
          "MTC wall air conditioner, 18,000 cold, golden blades, quadruple distribution, MTC18CO23",
        question_ar:
          "مكيف MTC جداري 18000 بارد ريش ذهبية توزيع رباعي MTC18CO23",
        answer_en: `MTC air conditioner is an economical option for those looking for a cheap 18-unit split air
        conditioner without sacrificing quality or performance. It has a compact design and golden
        fins that improve cooling efficiency and increase durability. Quadruple air distribution ensures
        that cooling reaches all parts of the room evenly, providing an instantly comfortable and
        refreshing environment.`,
        answer_ar:
          "مكيف MTC يعد خيارًا اقتصاديًا لمن يبحث عن مكيف سبليت 18 وحدة رخيص دون التضحية بالجودة أو الأداء. يتمتع بتصميم مدمج وريش ذهبية تعمل على تحسين كفاءة التبريد وزيادة المتانة. التوزيع الرباعي للهواء يضمن وصول التبريد إلى كافة أنحاء الغرفة بشكل متساوي، ما يوفر بيئة مريحة ومنعشة بشكل فوري.",
      },
      {
        question_en: "Terim Split AC, 18,500 BTU cold (Wi-Fi), TRG18CS24WF",
        question_ar: "مكيف تيرم جداري 18500 وحدة بارد (واي فاي) TRG18CS24WF",
        answer_en: `Term air conditioner offers an ideal cooling solution thanks to its 18,500 BTU, making it ideal
        for medium and large rooms. It provides the ability to be controlled via Wi-Fi technology, and
        this air conditioner is distinguished by its modern and elegant design to suit modern homes.`,
        answer_ar:
          "مكيف تيرم يقدم حلاً مثاليًا للتبريد بفضل وحدته البالغة 18500 وحدة، مما يجعله مثاليًا للغرف المتوسطة والكبيرة. يوفر إمكانية التحكم فيه عبر تقنية الواي فاي ويتميز هذا المكيف بتصميمه العصري والأنيق ليلائم المنازل العصرية.",
      },
    ],
    category_id: 7711,
    image_url: "https://images-r2.dev-almanea.com/banner_EN1.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner1.png",
  },
  {
    "title-en": "The best split air conditioners with a power of 12,000 BTU",
    "title-ar": "أفضل مكيفات سبليت بقوة 12000 وحدة",
    "description-en": `For those looking for efficiency and performance in split air conditioners, the 12,000 BTU
    units are an ideal choice for small to medium spaces, such as small apartments, dorm
    rooms, or small offices. These air conditioners provide efficient and energy-efficient cooling
    with advanced technical features to ensure optimal comfort. Let us review some of the best
    12 unit split air conditioners available in Almanea. Each of these products provides ideal
    solutions for cooling small spaces, while emphasizing energy efficiency and elegant design.
    Whether you are looking for a 12 unit split air conditioner for cooling or heating, this list offers
    various options that meet all needs.`,
    "description-ar":
      "لمن يبحث عن الكفاءة والأداء المتميز في مكيفات السبليت، تعد الوحدات بقوة 12000 وحدة خيارًا مثاليًا للمساحات الصغيرة والمتوسطة، مثل الشقق الصغيرة، غرف النوم، أو المكاتب الصغيرة. توفر هذه المكيفات تبريدًا فعالًا واقتصاديًا في استهلاك الطاقة مع ميزات تقنية متقدمة لضمان راحة مثالية. دعونا نستعرض بعضًا من أفضل مكيفات سبليت 12 وحدة المتوفرة في المنيع. حيث كل من هذه المنتجات توفر حلولاً مثالية للتبريد في المساحات الصغيرة، مع التأكيد على الكفاءة في استهلاك الطاقة والتصميم الأنيق. سواء كنت تبحث عن مكيف سبلت 12 وحدة للتبريد أو التدفئة، فإن هذه القائمة تقدم خيارات متنوعة تلبي جميع الاحتياجات.",
    q_a: [
      {
        question_en:
          "Haam Gold Wall Air Conditioner, 12100 Celsius, Golden Fins, HM12CSM23GO",
        question_ar: "مكيف هام جداري الذهبي 12100 بارد ريش ذهبية HM12CSM23GO",
        answer_en: `The Haam 12,100 BTU wall-mounted air conditioner delivers excellent cooling for limited
        spaces. It features golden fins that enhance cooling efficiency and extend the life of the unit.
        Its elegant and golden design adds a touch of luxury to interior décor, with quadruple air
        distribution technology for uniform and rapid cooling throughout the room.`,
        answer_ar:
          "يقدم مكيف هام جداري بقوة 12100 وحدة تبريدًا ممتازًا للمساحات المحدودة. يتميز بريشه الذهبية التي تعزز من كفاءة التبريد وتطيل عمر الوحدة. تصميمه الأنيق والذهبي يضيف لمسة من الفخامة للديكور الداخلي، مع تقنية توزيع الهواء الرباعي لتبريد موحد وسريع في كل أرجاء الغرفة.",
      },
      {
        question_en:
          "MTC wall air conditioner, 11500 hot/cold, golden blades, quadruple distribution, MTC12HO23",
        question_ar:
          "مكيف MTC جداري 11800 بارد ريش ذهبية توزيع رباعي MTC12CO23",
        answer_en: `MTC 11,500 BTU air conditioner provides comfort in all seasons with cooling and heating
        options. With its golden fins and quadruple air distribution system, this air conditioner
        ensures efficient air distribution. It is an ideal choice for those seeking a temperate
        environment all year round without worrying about energy costs.`,
        answer_ar:
          "مكيف MTC بقوة 11800 وحدة يوفر الراحة في كل الفصول بفضل خيارات التبريد والتدفئة. مع ريشه الذهبية ونظام التوزيع الرباعي للهواء، يضمن هذا المكيف توزيع الهواء بكفاءة عالية. يعد خيارًا مثاليًا لمن يسعى للحصول على بيئة معتدلة طوال العام دون القلق بشأن تكاليف الطاقة.",
      },
      {
        question_en: "Terim Split AC, 11,900 BTU cold (Wi-Fi), TRG12CS24WF",
        question_ar: "مكيف تيرم جداري 11900 وحدة بارد (واي فاي) TRG12CS24WF",
        answer_en: `The Term air conditioner reflects innovation with a power of 11,900 BTU, making it ideal for
        efficiently cooling small rooms. It features a compact and practical design, with modern
        technologies that ensure superior performance and fast cooling. This air conditioner from
        Term is a great choice for those looking for advanced and reliable cooling solutions.`,
        answer_ar:
          "مكيف تيرم يعكس الابتكار بقوة 11900 وحدة، مما يجعله مثاليًا لتبريد الغرف الصغيرة بكفاءة. يتميز بتصميم مدمج وعملي، مع تقنيات حديثة تضمن أداءً فائقًا وتبريدًا سريعًا. يعد هذا المكيف من تيرم اختيارًا رائعًا لمن يبحث عن حلول تبريد متقدمة وموثوقة.",
      },
      {
        question_en:
          "Haam Golden Wall Air Conditioner 11900 H/C Golden Fins HM12HSM23GO",
        question_ar:
          "مكيف هام جداري الذهبي 11900 حار بارد ريش ذهبية HM12HSM23GO",
        answer_en: `Haam once again introduces an efficient 11,900 BTU air conditioner that offers both cooling
        and heating options, making it ideal for year-round use. With its golden fins and four-way
        distribution system, this air conditioner is an excellent choice for those who want maximum
        comfort in small spaces. Its elegant design makes it a valuable addition to any room.`,
        answer_ar:
          "تقدم هام مرة أخرى مكيفًا فعالًا بقوة 11900 وحدة يوفر خيارات التبريد والتدفئة، مما يجعله مثاليًا للاستخدام على مدار السنة. بريشه الذهبية ونظام التوزيع الرباعي، يعد هذا المكيف خيارًا ممتازًا لمن يرغب في الحصول على أقصى درجات الراحة في المساحات الصغيرة. تصميمه الأنيق يجعله إضافة قيمة لأي غرفة.",
      },
    ],
    category_id: 7712,
    image_url: "https://images-r2.dev-almanea.com/banner_EN2.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner2.png",
  },
  {
    "title-en": "The best split air conditioners with a capacity of 22,000 BTU",
    "title-ar": "أفضل مكيفات سبليت بقوة 22000 وحدة",
    "description-en": `For larger spaces that require high cooling power, 22,000 BTU split air conditioners are the
    ideal choice. These units provide amazing cooling performance, making them suitable for
    large homes, halls, or offices with large spaces. It is characterized by its high energy
    efficiency and ability to quickly provide a refreshing and comfortable environment. In this
    dedicated list, we review some of the best 22 unit split air conditioners available in Almanea.
    22 Unit Split Air Conditioners and 22 Unit Split Air Conditioners are the ideal solutions to
    meet your cooling needs efficiently and effectively.`,
    "description-ar":
      "للمساحات الأكبر التي تتطلب قوة تبريد عالية، تعتبر مكيفات سبليت بقوة 22000 وحدة الخيار الأمثل. توفر هذه الوحدات أداءً مذهلاً في التبريد، مما يجعلها مناسبة للمنازل الكبيرة، القاعات، أو المكاتب ذات المساحات الواسعة. تتميز بكفاءتها العالية في استهلاك الطاقة وقدرتها على توفير بيئة منعشة ومريحة بسرعة. نستعرض  في هذه القائمة المخصصة بعضًا من أفضل مكيفات سبليت 22 وحدة التي توفرها في المنيع. مكيفات سبلت 22 وحدة ومكيف سبليت 22 وحدة هي الحلول المثالية لتلبية احتياجات التبريد الخاصة بك بكفاءة وفعالية.",
    q_a: [
      {
        question_en: "Haam Split AC,22000 BTU Cold, HM24CSM23GO",
        question_ar: " مكيف هام جداري الذهبي 22000 بارد ريش ذهبية HM24CSM23GO",
        answer_en: `The Haam Gold Wall Air Conditioner unit offers exceptional cooling performance with the
        golden feathers feature that enhances its durability and efficiency. Its elegant design makes
        it a perfect addition to any space and ensures efficient air circulation for fast and effective
        cooling.`,
        answer_ar:
          "يقدم مكيف هام جداري الذهبي وحدة أداءً استثنائيًا في التبريد مع ميزة الريش الذهبية التي تعزز من متانته وكفاءته. تصميمه الأنيق يجعله إضافة مثالية لأي مكان، ويضمن توزيع الهواء بكفاءة لتبريد سريع وفعال.",
      },
      {
        question_en: "Terim Split AC, 22,100 BTU cold (Wi-Fi) TRG24CS24WF",
        question_ar: "مكيف تيرم جداري 22100 وحدة بارد (واي فاي) TRG24CS24WF",
        answer_en: `The Terim 22100 wall air conditioner is the ideal choice for anyone looking for highly efficient
        cooling in large spaces. This air conditioner is distinguished by its advanced technology and
        its high ability to distribute air evenly throughout the room, providing a permanently
        comfortable and refreshing environment.`,
        answer_ar:
          "مكيف تيرم جداري بقوة 22100 يعد الخيار المثالي لمن يبحث عن تبريد فائق الكفاءة في المساحات الكبيرة. يتميز هذا المكيف بتقنيته المتقدمة وقدرته العالية على توزيع الهواء بشكل متساوي في كافة أنحاء الغرفة، مما يوفر بيئة مريحة ومنعشة بشكل دائم.",
      },
      {
        question_en: "Haam Split AC,22000 BTU Cold/Hot , HM24HSM23GO",
        question_ar:
          "مكيف هام جداري الذهبي22000  حار بارد ريش ذهبية HM24HSM23GO-NU",
        answer_en: `The Haam Gold wall air conditioner is distinguished by providing advanced cooling solutions
        thanks to its power of up to 22,000 units. This air conditioner is very suitable for areas with
        high temperatures, providing a cool and refreshing environment with high efficiency and
        energy-saving consumption. The air conditioner provides superior cooling and has
        homogeneous air distribution that ensures comfort in every corner of your home.`,
        answer_ar:
          "مكيف هام جداري الذهبي يتميز بتقديمه حلول تبريد متطورة بفضل قوته التي تصل إلى 22000 وحدة. يعد هذا المكيف مناسبًا للغاية للمناطق ذات الحرارة العالية، موفرًا بيئة باردة ومنعشة بكفاءة عالية واستهلاك موفر للطاقة. يوفر المكيف تبريدًا فائقًا ويمتاز بتوزيع هواء متجانس يضمن الراحة في كل زاوية من منزلك.",
      },
    ],
    category_id: 7713,
    image_url: "https://images-r2.dev-almanea.com/banner_EN3.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner3.png",
  },
  {
    "title-en": "Best Samsung Split Air Conditioners",
    "title-ar": "أفضل مكيفات سبليت من سامسونج",
    "description-en": ``,
    "description-ar": ``,
    q_a: [
      {
        question_en: "Samsung WindFree Split AC - 17,500 BTU - Hot/Cold",
        question_ar: "مكيف سامسونج (ويند فري) جداري 17,500 وحدة - حار/ بارد",
        answer_en: `The Samsung WindFree Split AC offers efficient cooling with its 17,500 BTU capacity, perfect for medium rooms. Designed for year-round comfort, it provides both hot and cold air, ensuring your space is comfortable in any season.
This model is energy-efficient, helping you save on electricity bills while maintaining optimal performance. With its WindFree technology, you can enjoy a quieter, draft-free environment, making it ideal for bedrooms or living rooms. The sleek design complements any interior, and the easy-to-use controls enhance convenience, making it a reliable and stylish choice for your cooling and heating needs.
`,
        answer_ar: `يوفر مكيف الهواء سبليت WindFree من سامسونج تبريدًا فعالاً بسعة 17,500 وحدة حرارية بريطانية، مما يجعله مثاليًا للغرف المتوسطة. مصمم لتوفير الراحة على مدار العام، فهو يوفر الهواء الساخن والبارد، مما يضمن أن المساحة الخاصة بك مريحة في أي موسم.
هذا الطراز موفر للطاقة، مما يساعدك على توفير فواتير الكهرباء مع الحفاظ على الأداء الأمثل. بفضل تقنية WindFree، يمكنك الاستمتاع ببيئة أكثر هدوءًا وخالية من تيارات الهواء، مما يجعل هذا المكيف مثالي لغرف النوم أو غرف المعيشة.
بتصميمه الأنيق يندمج هذا المكيف مع أي مساحة أو تصميم، كما تعمل خيارات التحكم سهلة الاستخدام على تعزيز الراحة بتمكينك من التحكم بتفاصيل عمل المكيف.
`,
      },
      {
        question_en:
          "Samsung Triple Inverter Split AC - 20,500 BTU - Hot / Cold",
        question_ar:
          "مكيف سامسونج (تريبل انفيرتر) جداري 20,500 وحدة - حار/ بارد",
        answer_en: `This split AC with Triple Inverter Technology delivers powerful and efficient climate control with a 20,500 BTU capacity, suitable for larger spaces. Offering both hot and cold air, it ensures your comfort throughout the year. The Triple Inverter boosts energy efficiency, reducing your electricity costs while maintaining top-notch performance. 
This model Reduces noise and energy use by about 73%. It operates quietly, making it perfect for any room in your home. Its modern design seamlessly fits into any decor, and the user-friendly controls make it easy to customize your comfort. For reliable and energy-efficient heating and cooling, this Samsung Split AC is an excellent choice.
`,
        answer_ar: `يوفر مكيف الهواء المنفصل المزود بتقنية العاكس الثلاثي تحكمًا قويًا وفعالًا في المناخ بسعة 20,500 وحدة حرارية بريطانية، وهو مناسب للمساحات الكبيرة. يوفر التكييف الحار أو البارد، مما يضمن راحتك طوال العام.

يعمل العاكس الثلاثي على تعزيز كفاءة الطاقة، مما يقلل من تكاليف الكهرباء مع الحفاظ على الأداء المتميز.
هذا المكيف يقلل من الضوضاء واستخدام الطاقة بحوالي 73%. يعمل بهدوء، مما يجعله مثاليًا لأي غرفة في منزلك. يتناسب تصميمه الحديث مع أي ديكور بسلاسة، وتسهل أدوات التحكم سهلة الاستخدام تخصيص راحتك. للحصول على التدفئة والتبريد الموثوقة والموفرة للطاقة، يعد هذا الموديل خيارًا ممتازًا.
`,
      },
      {
        question_en:
          "Samsung WindFree Split Air Conditioner - 20,500 BTU - Hot/ Cold",
        question_ar: "مكيف سامسونج (ويند فري) جداري 20,500 وحدة - حار/ بارد",
        answer_en: `The Samsung WindFree Split Air Conditioner offers a 20,500 BTU capacity, making it ideal for homes with open spaces and large rooms. Unlike other ACs, with its WindFree technology, it provides consistent cooling without the discomfort of direct airflow, perfect for maintaining a pleasant environment year-round. It operates with both hot and cold air, making it versatile for all seasons. 
The unit is energy-efficient, thanks to its advanced features, it can cool space quickly and efficiently using a bigger fan that allows higher volumes of air without the need to blow it fast. This results in a comfortable, efficient, and fast cooling
`,
        answer_ar: `يوفر مكيف الهواء سبليت WindFree من سامسونج سعة 20,500 وحدة حرارية بريطانية، مما يجعله مثاليًا للمنازل ذات المساحات المفتوحة والغرف الكبيرة. على عكس أجهزة التكييف الأخرى، بفضل تقنية WindFree، فإنه يوفر تبريدًا ثابتًا دون إزعاج تدفق الهواء المباشر، مما يجعله مثاليًا للحفاظ على بيئة ممتعة على مدار العام. يوفر التكييف الساخن والبارد، مما يجعله متعددة الاستخدامات لجميع الفصول.
يتميز هذا المكيف بأنه موفر للطاقة، وذلك بفضل ميزاته المتقدمة، حيث يمكنه تبريد المساحة بسرعة وكفاءة باستخدام مروحة أكبر تسمح بكميات أكبر من الهواء دون الحاجة إلى تحريكها بسرعة. وينتج عن ذلك تبريد مريح، فعال، وسريع.
`,
      },
    ],
    category_id: 7714,
    image_url: "https://images-r2.dev-almanea.com/banner_EN6.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner6.png",
  },
  {
    "title-en": "Best LG split air conditioners",
    "title-ar": "أفضل مكيفات LG سبليت",
    "description-en": `LG is one of the leading brands in the air conditioner industry, offering a wide range of split
    air conditioners that are distinguished by their high efficiency, elegant design, and advanced
    technology. Whether you are looking for cooling solutions for your home or office, <a href="https://www.almanea.sa/lg-c-7544/air-conditioners-c-7548" style="color: blue; text-decoration: underline;" target="_blank"> LG split air
    conditioners </a> offer the perfect combination of powerful performance and energy efficiency. Below, we review some of the best LG split air conditioners offered by Almanea, which are
    an excellent choice for those looking for exceptional cooling quality and innovative
    technologies. LG split air conditioners offer advanced solutions for cooling homes and
    offices, while remaining committed to providing the highest standards of quality and
    innovation. Whether you are looking for efficient cooling or reliable heating options, LG split
    air conditioners offer everything you need to provide a comfortable and refreshing living
    environment.`,
    "description-ar": `تُعد LG واحدة من العلامات التجارية الرائدة في صناعة مكيفات الهواء، حيث تقدم مجموعة واسعة من مكيفات السبليت التي تتميز بكفاءتها العالية، تصميمها الأنيق، وتكنولوجيتها المتطورة. سواء كنت تبحث عن حلول تبريد لمنزلك أو مكتبك، فإن <a href="https://www.almanea.sa/lg-c-7544/air-conditioners-c-7548" style="color: blue; text-decoration: underline;" target="_blank">مكيفات إل جى</a> سبليت تقدم مزيجًا مثاليًا من الأداء القوي والتوفير في استهلاك الطاقة. فيما يلي نستعرض بعضًا من أفضل مكيفات سبليت LG توفرها المنيع، والتي تعد خيارًا ممتازًا لمن يبحث عن جودة تبريد استثنائية وتقنيات مبتكرة. تقدم مكيفات سبليت LG حلولًا متطورة لتبريد المنازل والمكاتب، مع التزامها بتوفير أعلى معايير الجودة والابتكار. سواء كنت تبحث عن تبريد فعّال أو خيارات تدفئة موثوقة، فإن مكيفات LG سبليت تقدم لك كل ما تحتاجه لتوفير بيئة معيشية مريحة ومنعشة.`,
    q_a: [
      {
        question_en:
          "LG Jet Cool Air Conditioner 18400 BTU Cold LO182C0 NK0 LO182C0 UK0",
        question_ar: "مكيف LG جيت كول 18400 وحدة بارد LO182C0 NK0 LO182C0 UK0",
        answer_en: `This air conditioner from LG is characterized by its ability to provide fast and effective cooling
        with energy-efficient consumption, making it an ideal choice for medium spaces. The LG split
        air conditioner is equipped with Jet Cool technology that ensures fast and even cooling
        throughout the room.`,
        answer_ar:
          "يتميز هذا المكيف من LG بقدرته على توفير تبريد سريع وفعال مع استهلاك موفر للطاقة، مما يجعله خيارًا مثاليًا للمساحات المتوسطة. يعتبر مكيف LG سبليت مزودًا بتقنية Jet Cool التي تضمن تبريدًا سريعًا ومتساويًا في جميع أنحاء الغرفة.",
      },
      {
        question_en:
          "LG Jet Cool Air Conditioner 22800 BTU Cold LO242C0 NK0 LO242C0 UK0",
        question_ar: "مكيف LG جيت كول 22800 وحدة بارد LO242C0 NK0 LO242C0 UK0",
        answer_en: `With a cooling capacity of up to 22,800 BTU, this air conditioner is the perfect choice for
        large spaces. It has high cooling efficiency while maintaining low noise levels, providing a
        quiet and comfortable environment.`,
        answer_ar:
          "مع قدرة تبريد تصل إلى 22800 وحدة، يعد هذا المكيف الخيار الأمثل للمساحات الكبيرة. يتميز بكفاءته العالية في التبريد مع الحفاظ على مستويات ضوضاء منخفضة، موفرًا بيئة هادئة ومريحة.",
      },
      {
        question_en:
          "LG Fresh Inverter Air Conditioner 18000 Hot/Cold NF182H2 NK1 - NF182H2 UK1",
        question_ar:
          "مكيف LG فريش انفرتر 18000 حار بارد NF182H2 NK1 - NF182H2 UK1",
        answer_en: `This air conditioner from LG combines cooling and heating functions in one device, making it
        ideal for use all year round. Equipped with inverter technology that ensures high energy
        efficiency and outstanding performance in space cooling and heating.`,
        answer_ar:
          "هذا المكيف من LG يجمع بين وظائف التبريد والتدفئة في جهاز واحد، مما يجعله مثاليًا للاستخدام طوال العام. مزود بتكنولوجيا الانفرتر التي تضمن كفاءة عالية في استهلاك الطاقة وأداءً متميزًا في تبريد وتدفئة المساحات.",
      },
      {
        question_en:
          "LG Fresh Inverter Air Conditioner 21500 Cold NF242C3 NK1 - NF242C3 UK1",
        question_ar: "مكيف LG فريش انفرتر 21500 بارد NF242C3 NK1 - NF242C3 UK1",
        answer_en: `LG&#39;s 21,500 BTU air conditioner provides exceptional cooling for large spaces, with inverter
        technology that helps reduce energy consumption without affecting cooling performance. It is
        distinguished by its modern design that fits with all interior decors.`,
        answer_ar:
          "مكيف LG بقوة 21500 وحدة يوفر تبريدًا استثنائيًا للمساحات الكبيرة، مع تقنية الانفرتر التي تساعد على تقليل استهلاك الطاقة دون التأثير على أداء التبريد. يتميز بتصميمه العصري الذي يتناسب مع جميع الديكورات الداخلية.",
      },
    ],
    category_id: 7715,
    image_url: "https://images-r2.dev-almanea.com/banner_EN5.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner5.png",
  },
  {
    "title-en": "The Best Gree Air Conditioners",
    "title-ar": "أفضل مكيفات جري",
    "description-en": `Gree is considered one of the global leaders in the air conditioning industry, and is famous
    for providing high-quality, technologically advanced, and energy-efficient air conditioners.
    Gree split air conditioners are distinguished by their strong performance and their ability to
    provide a refreshing and comfortable environment at different times and spaces. Whether
    you are looking for cooling solutions for your home or office, Gree air conditioners offer you a
    wide selection that meets all your needs. Below we review some of the best Gree air
    conditioners available, which are an excellent choice for optimal and energy-efficient cooling.
    Gree split air conditioners provide an optimal cooling experience with their commitment to
    innovation and sustainability. Whether you are looking for a Gree 24 air conditioner or a
    Gree split air conditioner with any other power, Gree provides multiple options that meet all
    cooling requirements and needs with high efficiency and energy-saving consumption.`,
    "description-ar":
      "تعتبر شركة جري واحدة من الرواد العالميين في صناعة أجهزة التكييف، حيث تشتهر بتقديمها لمكيفات عالية الجودة، متطورة تقنيًا، وفعالة من حيث استهلاك الطاقة. تتميز مكيفات جري سبليت بأدائها القوي وقدرتها على توفير بيئة منعشة ومريحة في مختلف الأوقات والمساحات. سواء كنت تبحث عن حلول تبريد لمنزلك أو مكتبك، فإن مكيفات Gree تقدم لك تشكيلة واسعة تلبي كافة احتياجاتك. فيما يلي نستعرض بعضًا من أفضل مكيفات جري المتوفرة، التي تعد خيارًا ممتازًا للحصول على تبريد مثالي وموفر للطاقة. مكيفات جري سبليت تقدم تجربة تبريد مثالية مع التزامها بالابتكار والاستدامة. سواء كنت تبحث عن مكيف جري 24 أو مكيف سبليت جري بأي قوة أخرى، فإن جري توفر خيارات متعددة تلبي جميع متطلبات واحتياجات التبريد بكفاءة عالية واستهلاك موفر للطاقة.",
    q_a: [
      {
        question_en:
          "Gree Polar Split AC 11600 BTU, Cold, GWC12AGC-D3NTA1A/I GWC12AGC-D3NTA1A/O",
        question_ar:
          "Gree Polar Split AC 11600 BTU, Cold, GWC12AGC-D3NTA1A/I GWC12AGC-D3NTA1A/O",
        answer_en: `This Gree air conditioner provides 11,600 BTU of efficient cooling, making it suitable for
        small and medium rooms. It is characterized by its energy efficiency and modern design that
        suits every decor.`,
        answer_ar:
          "يوفر هذا المكيف من جري تبريدًا فعالًا بقوة 11600 BTU، مما يجعله مناسبًا للغرف الصغيرة والمتوسطة. يتميز بكفاءته في استهلاك الطاقة وتصميمه العصري الذي يناسب كل ديكور.",
      },
      {
        question_en:
          "Gree Polar Split AC 18500 BTU, Cold, GWC18AGDXF- D3NTA1F/I GWC18AGDXF-D3NTA1F/O",
        question_ar:
          "Gree Polar Split AC 18500 BTU, Cold, GWC18AGDXF-D3NTA1F/I GWC18AGDXF-D3NTA1F/O",
        answer_en: `With a cooling power of up to 18,500 BTU, this air conditioner is the perfect choice for
        medium to large spaces. Ensures reliable performance and fast cooling to provide
        comfortable ambiance with minimal energy consumption.`,
        answer_ar:
          "مع قوة تبريد تصل إلى 18500 BTU، يعد هذا المكيف الخيار الأمثل للمساحات المتوسطة إلى الكبيرة. يضمن أداءً موثوقًا وتبريدًا سريعًا لتوفير أجواء مريحة بأقل استهلاك للطاقة.",
      },
      {
        question_en:
          "Gree Polar Split AC 22100 BTU, Cold, GWC24AGEXF- D3NTA1A/I GWC24AGEXF-D3NTA1A/O",
        question_ar:
          "Gree Polar Split AC 22100 BTU, Cold, GWC24AGEXF-D3NTA1A/I GWC24AGEXF-D3NTA1A/O",
        answer_en: `This 22,100 BTU air conditioner is the perfect solution for very large spaces, as it provides
        outstanding cooling while maintaining efficient energy consumption. It features advanced
        running technologies that ensure long-lasting performance and ultra-efficient cooling.`,
        answer_ar:
          "هذا المكيف بقوة 22100 BTU هو الحل الأمثل للمساحات الكبيرة جدًا، حيث يوفر تبريدًا متميزًا مع الحفاظ على استهلاك طاقة موفر. يتميز بتقنيات جري المتطورة التي تضمن أداءً طويل الأمد وتبريدًا فائق الكفاءة.",
      },
      {
        question_en: "Terim Split AC, 18,500 BTU cold (Wi-Fi), TRG18CS24WF",
        question_ar: "مكيف تيرم جداري 18500 وحدة بارد (واي فاي) TRG18CS24WF",
        answer_en: `Term air conditioner offers an ideal cooling solution thanks to its 18,500 BTU, making it ideal
        for medium and large rooms. It provides the ability to be controlled via Wi-Fi technology, and
        this air conditioner is distinguished by its modern and elegant design to suit modern homes.`,
        answer_ar:
          "مكيف تيرم يقدم حلاً مثاليًا للتبريد بفضل وحدته البالغة 18500 وحدة، مما يجعله مثاليًا للغرف المتوسطة والكبيرة. يوفر إمكانية التحكم فيه عبر تقنية الواي فاي ويتميز هذا المكيف بتصميمه العصري والأنيق ليلائم المنازل العصرية.",
      },
    ],
    category_id: 7716,
    image_url: "https://images-r2.dev-almanea.com/banner_EN4.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner4.png",
  },
  {
    "title-en": "Best Haam split air conditioners",
    "title-ar": "أفضل مكيفات سبليت هام",
    "description-en": `Haam air conditioners are distinguished by providing advanced technology and innovative
    cooling solutions that suit all needs and spaces. Thanks to their modern designs and strong
    performance, HAAM air conditioners continue to gain consumers&#39; trust with their high-quality
    and energy-efficient products. Whether you want a refreshing environment during the
    summer or warm in the winter, HAAM air conditioners offer a wide range of options that
    combine advanced technology with environmental sustainability. Let&#39;s take a look at some of
    the best Hasm split air conditioners available in Almanea, which are a great option for anyone
    seeking to combine efficiency and elegance in cooling their home or office.`,
    "description-ar":
      "تمتاز مكيفات هام بتقديمها لتكنولوجيا متطورة وحلول تبريد مبتكرة تلائم كافة الاحتياجات والمساحات. بفضل تصميماتها العصرية وأدائها القوي، مكيفات هام تستمر في كسب ثقة المستهلكين بمنتجاتها ذات الجودة العالية والكفاءة العالية في استهلاك الطاقة. سواء كنت ترغب في الحصول على بيئة منعشة خلال فصل الصيف أو دافئة في الشتاء، توفر مكيفات هام مجموعة واسعة من الخيارات التي تجمع بين التقنية المتقدمة والاستدامة البيئية. دعونا نلقي نظرة على بعض من أفضل مكيفات سبليت هام المتاحة في المنيع، والتي تعد خيارًا رائعًا لمن يسعى للجمع بين الفعالية والأناقة في تبريد منزله أو مكتبه.",
    q_a: [
      {
        question_en: "Haam Split AC, 28000 BTU, Cold, HM30CSM23GONU",
        question_ar: "مكيف هام جداري الذهبي 18300 بارد ريش ذهبية HM18CSM23GO",
        answer_en: `The Haam 28,000 BTU split air conditioner provides excellent cooling for large spaces,
        making it the ideal choice for halls, spacious halls, or large offices. It is characterized by its
        high cooling efficiency and modern design that adds a touch of elegance to any place.`,
        answer_ar:
          "يقدم هذا المكيف من هام تبريدًا متميزًا بقوة 18300 BTU، مما يجعله مناسبًا لتبريد المساحات المتوسطة. يتمتع بكفاءة عالية في استهلاك الطاقة وتصميم جذاب بريش ذهبية، مما يضفي لمسة من الأناقة إلى أي مكان. توفر تقنية الريش الذهبية متانة أكبر وتحسينًا في أداء التبريد، ما يضمن بيئة منعشة ومريحة باستمرار.",
      },
      {
        question_en: "Haam Split AC,18300 BTU Cold, HM18CSM23GO",
        question_ar: "Haam Split AC, 28000 BTU, Cold, HM30CSM23GONU",
        answer_en: `This air conditioner from Haam offers an outstanding cooling power of 18,300 BTU, making
        it suitable for cooling medium spaces. It has high energy efficiency and an attractive design
        with golden feathers, adding a touch of elegance to any space. Gold feather technology
        provides greater durability and improved cooling performance, ensuring a consistently fresh
        and comfortable environment.`,
        answer_ar:
          "يقدم مكيف هام سبليت بقوة 28000 BTU تبريدًا متميزًا للمساحات الكبيرة، مما يجعله الخيار الأمثل للقاعات، الصالات الواسعة، أو المكاتب الكبيرة. يتميز بكفاءته العالية في التبريد وتصميمه العصري الذي يضيف لمسة من الأناقة إلى أي مكان.",
      },
    ],
    category_id: 7717,
    image_url: "https://images-r2.dev-almanea.com/banner_EN7.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner7.png",
  },
  {
    "title-en": "Best General Air Conditioners",
    "title-ar": "أفضل مكيفات جنرال",
    "description-en": `The General brand is famous for offering a range of <a target="_blank" href="https://www.almanea.sa/general-c-7606" style="color: blue; text-decoration: underline;">split ACs </a> that combine high cooling
    efficiency with modern designs that suit all places and tastes. These air conditioners are
    distinguished by their advanced technologies and their ability to provide a refreshing and
    comfortable environment with minimal energy consumption, making them a preferred choice
    for many customers looking for reliable quality and unparalleled performance. General air
    conditioners continue to prove their efficiency and quality in the market, providing consumers
    with advanced cooling solutions that suit all their needs. General offers multiple options that
    combine high performance with elegant design to provide the best possible cooling
    experience. Below, we review the best General air conditioners in Manea, which are the
    ideal choice for everyone who wants to enjoy an exceptional cooling experience.`,
    "description-ar": `تشتهر علامة جنرال بتقديمها لمجموعة من  <a target="_blank" href="https://www.almanea.sa/general-c-7606" style="color: blue; text-decoration: underline;">مكيفات سبليت جنرال</a> التي تجمع بين الكفاءة العالية في التبريد والتصميمات العصرية التي تناسب كل الأماكن والأذواق. تتميز هذه المكيفات بتقنياتها المتقدمة وقدرتها على توفير بيئة منعشة ومريحة بأقل استهلاك للطاقة، مما يجعلها خيارًا مفضلًا للعديد من العملاء الباحثين عن جودة موثوقة وأداء لا يضاهى. حيث تستمر مكيفات جنرال في إثبات كفاءتها وجودتها في السوق، مقدمةً للمستهلكين حلول تبريد متقدمة تلائم كافة احتياجاتهم. جنرال تقدم خيارات متعددة تجمع بين الأداء العالي والتصميم الأنيق لتوفير أفضل تجربة تبريد ممكنة. فيما يلي، نستعرض أفضل مكيفات جنرال في المنيع، والتي تعد الخيار الأمثل لكل من يرغب في الاستمتاع بتجربة تبريد استثنائية.`,
    q_a: [
      {
        question_en:
          "General wall air conditioner, 24,000 BTU cold, ASSA24FUTA, AOSA24FUTAH",
        question_ar:
          "مكيف اوجنرال جدارى 24000 وحدة بارد ASSA24FUTA AOSA24FUTAH",
        answer_en: `This air conditioner from General offers efficient and fast cooling with a power of 24,000
        BTU, making it ideal for medium and large spaces. It features an advanced cooling system
        that ensures even air distribution throughout the room, providing a refreshing environment in
        the shortest possible time.`,
        answer_ar:
          "يقدم هذا المكيف من جنرال تبريدًا فعالًا وسريعًا بقوة 24000 وحدة، مما يجعله مثاليًا للمساحات المتوسطة والكبيرة. يتميز بنظام تبريد متطور يضمن توزيع الهواء بشكل متساوٍ في جميع أنحاء الغرفة، موفرًا بيئة منعشة في أقصر وقت ممكن.",
      },
      {
        question_en:
          "General wall air conditioner, 26,400 units, hot and cold, ASSA30UUTA, AOSA30UUT",
        question_ar:
          "مكيف اوجنرال جدارى 26400 وحدة حار بارد ASSA30UUTA AOSA30UUT",
        answer_en: `This air conditioner is the ideal solution for users looking for an option that meets their needs
        in all seasons, thanks to its ability to cool and heat very efficiently. With a power of 26,400
        BTU, it provides ideal cooling and heating for large spaces, ensuring complete comfort all
        year round.`,
        answer_ar:
          "هذا المكيف يعد الحل الأمثل للمستخدمين الباحثين عن خيار يلبي احتياجاتهم في كل الفصول، بفضل قدرته على التبريد والتدفئة بكفاءة عالية. مع قوة 26400 وحدة، يوفر تبريدًا وتدفئة مثالية للمساحات الواسعة، ضامنًا راحة تامة طوال العام.",
      },
      {
        question_en:
          "General wall air conditioner, 19,600 BTU cold, ASSA18FUTA, AOSA18FUTAH",
        question_ar:
          "مكيف اوجنرال جدارى 19600 وحدة بارد ASSA18FUTA AOSA18FUTAH",
        answer_en: `Ideal for small to medium rooms, this General air conditioner delivers powerful and efficient
        19,600 BTU cooling. It is distinguished by its modern design and advanced cooling system
        that ensures efficient air distribution throughout the room.`,
        answer_ar:
          "مثالي للغرف الصغيرة والمتوسطة، يوفر هذا المكيف من جنرال تبريدًا قويًا وفعالًا بقوة 19600 وحدة. يتميز بتصميمه العصري ونظام التبريد المتطور الذي يضمن توزيع الهواء بكفاءة في كل أنحاء الغرفة.",
      },
    ],
    category_id: 7718,
    image_url: "https://images-r2.dev-almanea.com/banner_EN8.png",
    image_ar_url: "https://images-r2.dev-almanea.com/banner8.png",
  },
];

export const InfoDishwashers = [
  {
    "title-en": "How to Choose the Right Dishwasher Size",
    "title-ar": "كيف تختار حجم غسالة الصحون المناسب؟",
    "description-en": `it’s important to consider the available space in your
    kitchen and your needs in terms of the number of dishes you want to wash at once.
    Dishwashers generally come in small, medium, and large sizes, each offering different
    advantages to suit specific uses.`,
    "description-ar":
      "عند اختيار احجام غسالة الصحون المناسبة، من المهم مراعاة حجم مساحتك المتاحة واحتياجاتك من ناحية كمية الأواني والصحون التي ترغب في غسلها دفعة واحدة. تتراوح أحجام غسالات الصحون بشكل عام بين الأحجام الصغيرة والمتوسطة والكبيرة، كلٌ منها يقدم مزايا مختلفة تناسب استخدامات معينة.",
    q_a: [
      {
        question_en: "Small and Compact Dishwashers",
        question_ar: "لغسالات الصغيرة والمدمجة",
        answer_en: `These are perfect for kitchens with limited space or for individuals who don’t have many dishes
        to wash daily. They can be placed on countertops or installed in designated spaces under sinks.
        Despite their small size, they are highly effective in cleaning and ideal for small households or
        apartments.`,
        answer_ar: `هذه الغسالات مثالية للمطابخ ذات المساحات المحدودة أو للأشخاص الذين لا يملكون الكثير من الأواني لغسلها بشكل يومي. يمكن وضعها على الأسطح أو تثبيتها في أماكن مخصصة تحت الأحواض. على الرغم من صغر حجمها، فإنها فعّالة للغاية في التنظيف ومثالية للأسر الصغيرة أو الشقق.`,
      },
      {
        question_en: "Medium-Sized Dishwashers",
        question_ar: "الغسالات متوسطة الحجم",
        answer_en: `These are the best choice for most families, providing enough space to wash a moderate
        amount of dishes and utensils. They fit well with most kitchen designs without requiring a lot of
        space.`,
        answer_ar:
          "تعتبر الخيار الأمثل لمعظم الأسر، حيث توفر مساحة كافية لغسل كميات متوسطة من الصحون والأواني. تتميز بكونها تتناسب مع معظم تصاميم المطابخ دون الحاجة إلى تخصيص مساحة كبيرة لها.",
      },
      {
        question_en: "Large Dishwashers",
        question_ar: "الغسالات الكبيرة",
        answer_en: `Designed for large families or those who frequently host gatherings and need to wash a large
        number of dishes at once. These dishwashers offer ample space and multiple wash programs to
        handle all types of dishes and utensils.`,
        answer_ar:
          "صمم هذه الغسالات للأسر الكبيرة أو الأشخاص الذين يستضيفون تجمعات بشكل متكرر ويحتاجون إلى غسل كميات كبيرة من الصحون دفعة واحدة. توفر هذه الغسالات مساحة واسعة وعدة برامج غسيل للتعامل مع جميع أنواع الأواني والصحون.",
      },
    ],
    products: Washer1,
  },
  {
    "title-en": "Dishwasher User Guide",
    "title-ar": "دليل استخدام غسالة الصحون",
    "description-en": `To effectively operate your dishwasher, let’s use Midea dishwashers as an
    example for optimal usage. This guide will cover the basic steps from setup
    to selecting programs and special features, ensuring you use your
    dishwasher efficiently and easily.`,
    "description-ar":
      "لفهم تشغيل غساله الصحون بشكل فعال، دعونا نأخذ غسالات ميديا كمثال للتعرف على الاستخدام الأمثل لهذه الأجهزة. من خلال هذا الدليل، سنستعرض الخطوات الأساسية من الإعداد إلى اختيار البرامج والميزات الخاصة، مما يضمن لك استخدام غسالة الصحون بكفاءة وسهولة.",
    q_a: [
      {
        question_en: "Basic Setup:",
        question_ar: "الإعداد الأساسى",
        answer_en: `Before operating the dishwasher, ensure it is connected
        to the water and power supply according to the manufacturer’s
        instructions. Place dishes and utensils inside the dishwasher in an
        organized manner to allow water and soap to circulate freely.`,
        answer_ar: `قبل تشغيل غساله الصحون، تأكد من توصيلها بمصدر الماء والكهرباء وفقًا لتعليمات الشركة المصنعة. يجب وضع الصحون والأواني داخل الغسالة بطريقة منظمة لتسمح بمرور الماء والصابون بينها بسهولة.`,
      },
      {
        question_en: "Choosing the Right Detergent:",
        question_ar: "اختيار المنظف المناسب",
        answer_en: `Use a detergent specifically designed
        for dishwashers to avoid damage to the machine or dishes.`,
        answer_ar:
          "استخدم منظف خاص بغسالات الصحون لتجنب أي ضرر قد يحدث للجهاز أو الأواني.",
      },
      {
        question_en: "Loading the Dishwasher:",
        question_ar: "تحميل الغسالة:",
        answer_en: `Place large pots and plates on the bottom
        rack and cups and smaller utensils on the top rack. Ensure that bowls
        and cups are facing downwards for thorough cleaning.`,
        answer_ar: `ضع الأواني الكبيرة والأطباق في الأسفل والأكواب والأدوات الصغيرة في الأعلى. تأكد من فتح الأواني والأكواب نحو الأسفل لضمان تنظيفها جيدًا.`,
      },
      {
        question_en: "Selecting the Mode:",
        question_ar: "اختيار الوضع:",
        answer_en: `Midea dishwashers offer several cleaning
        modes, including quick, eco, and intensive. Choose the appropriate
        mode based on the amount and type of dishes to be cleaned.`,
        answer_ar: `طريقة استخدام غسالة صحون ميديا تشمل عدة أوضاع تنظيف، منها السريع، الاقتصادي، والمكثف. اختر الوضع المناسب بناءً على كمية ونوع الأواني المراد تنظيفها.`,
      },
      {
        question_en: "Operating the Dishwasher:",
        question_ar: "تشغيل الغسالة:",
        answer_en: `After selecting the appropriate mode,
        press the start button to begin the washing cycle. Some dishwashers
        feature additional options like delayed start, allowing you to set the
        wash cycle to begin at a later time.`,
        answer_ar: `بعد اختيار الوضع المناسب، اضغط على زر البدء لتبدأ طريقه تشغيل غساله الصحون. بعض الغسالات تتميز بميزات إضافية مثل التأخير في البدء، والتي تسمح بتأجيل بدء الغسل لوقت لاحق.`,
      },
      {
        question_en: "Maintenance:",
        question_ar: "صيانة الغسالة:",
        answer_en: `To maintain your dishwasher’s performance, regularly
        clean the filters and ensure that food residues are removed from the
        dishes before loading.`,
        answer_ar: `للحفاظ على أداء غسالة الصحون، نظف فلاتر الغسالة بانتظام وتأكد من إزالة بقايا الطعام من الأواني قبل وضعها في الغسالة`,
      },
    ],
    products: [],
  },
  {
    "title-en": "Top-Selling Dishwashers",
    "title-ar": "أفضل غسالات الصحون الأكثر مبيعًا",
    "description-en": `When it comes to the best and most popular dishwashers on the market,
    we look at the models that have gained customer trust through high sales
    at Almanea. These dishwashers are ranked based on sales volume,
    reflecting customer satisfaction and preference for these models. Here’s a
    look at some of the top-selling dishwashers, known for their high quality and
    excellent efficiency:`,
    "description-ar": `عندما نتحدث عن أفضل غساله صحون واحسن غساله صحون في السوق، فإننا ننظر إلى الأجهزة التي حازت على ثقة العملاء من خلال مبيعاتها المرتفعة في المنيع. تُصنف هذه الغسالات بناءً على كمية المبيعات، مما يعكس رضا العملاء وتفضيلهم لهذه الموديلات. إليكم نظرة على بعض من أكثر غسالات الصحون مبيعًا والتي تتميز بجودتها العالية وكفاءتها الممتازة:`,
    q_a: [
      {
        question_en:
          "Haam Dishwasher, 3 Racks, Silver, 14 Place Settings, 8 Programs (HM14PSDW18)",
        question_ar: "غسالة صحون هام 3 ارفف فضي 14 مكان 8 برامج HM14PSDW18",
        answer_en: `Featuring a large capacity for 14 place settings and 8 diverse programs,
        this dishwasher is perfect for large families or those who need to wash
        large quantities of dishes at once.`,
        answer_ar: `تتميز بسعتها الكبيرة لـ 14 مكان تحميل و8 برامج متنوعة، مما يجعلها مثالية للأسر الكبيرة أو لمن يحتاجون إلى غسل كميات كبيرة من الأواني دفعة واحدة.`,
      },
      {
        question_en:
          "Haam Dishwasher, 12 Place Settings, 7 Programs, Stainless Steel (HMDW1207S23)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23",
        answer_en: `Offering an ideal blend of efficiency and performance with its sleek
        stainless steel design. It comes with 7 wash programs suitable for different
        types of dishes and levels of dirt.`,
        answer_ar:
          "توفر مزيجاً مثالياً من الكفاءة والأداء مع تصميمها الأنيق باللون الفولاذي. تأتي مع 7 برامج غسيل تلائم مختلف أنواع الأواني ودرجات الاتساخ.",
      },
      {
        question_en:
          "Ariston Dishwasher, 7 Programs, Silver, 14 Place Settings (LFC 3C26 W X60HZ)",
        question_ar: "غسالة صحون اريستون 7 برامج فضي 14 مكان LFC 3C26 W X 60HZ",
        answer_en: `A favorite choice for those seeking efficiency and effectiveness, this model
        features 7 cleaning programs and a capacity of up to 14 place settings,
        making dishwashing a simple and easy task.`,
        answer_ar:
          " تعد من الخيارات المفضلة لمن يبحثون عن كفاءة وفعالية، مع 7 برامج تنظيف وسعة تصل إلى 14 مكان، تجعل من غسل الصحون مهمة سهلة وبسيطة",
      },
    ],
    products: Washer1,
    image_url: "/imgs/top-ten/w_3_en.jpg",
    image_ar_url: "/imgs/top-ten/w_3_ar.jpg",
  },
  {
    "title-en": "Affordable High-Quality Dishwashers",
    "title-ar": "ارخص غسالة صحون بجودة عالية",
    "description-en": `Finding an affordable dishwasher doesn’t mean compromising on quality or
    performance. There are many options available that offer excellent
    efficiency at reasonable prices, especially for those looking for budget - friendly kitchen solutions without sacrificing quality. With a budget of around
    1049 SAR, you can find dishwashers that are both effective and easy to
    use. Here are some of the best and most affordable dishwashers in this
    price range:`,
    "description-ar":
      "في البحث عن ارخص غسالة صحون، لا يعني ذلك التنازل عن الجودة أو الأداء. هناك العديد من الخيارات المتاحة التي توفر كفاءة ممتازة بأسعار معقولة، خاصةً لمن يبحث عن حلول اقتصادية لمطبخه دون التضحية بالجودة. بميزانية حوالي 1049 ريال سعودي، يمكنك العثور على غسالات صحون تتميز بالفعالية وسهولة الاستخدام. إليك بعض من أفضل وأرخص الغسالات في هذا النطاق السعري:",
    q_a: [
      {
        question_en:
          "Frigidaire Dishwasher, 12 Place Settings, 6 Programs, White (FDFE12FFGCWD)",
        question_ar: "غسالة صحون فريجدير 12 مكان 6 برامج ابيض FDFE12FFGCWD",
        answer_en: `With a capacity of 12 place settings and 6 wash programs, this dishwasher
        is an excellent choice for small to medium-sized families, all wrapped in a
        sleek and simple design.`,
        answer_ar:
          "تتميز بسعة تحميل تكفي لـ 12 مكان و6 برامج غسيل، ما يجعلها خياراً ممتازاً للعائلات الصغيرة والمتوسطة، كل ذلك بتصميم أنيق وبسيط.",
      },
      {
        question_en:
          "Xper Dishwasher, Silver, 14 Place Settings, 6 Programs (DW1400SXP20)",
        question_ar: "غسالة صحون اكسبير فضي 14 مكان 6 برامج DW1400SXP20",
        answer_en: `This dishwasher offers a larger capacity for 14 place settings and 6 wash
        programs, making it suitable for larger families looking for effective
        performance at an economical price.`,
        answer_ar:
          "توفر هذه الغسالة سعة أكبر لـ 14 مكان و6 برامج غسيل، مما يجعلها مناسبة للأسر الأكبر حجمًا التي تبحث عن أداء فعال بسعر اقتصادي.",
      },
      {
        question_en:
          "Haam Dishwasher, 12 Place Settings, 7 Programs, Stainless Steel (HMDW1207S23)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23",
        answer_en: `Combining elegance and efficiency, this dishwasher comes with 7 wash
        programs to meet various needs and preferences, all while maintaining an
        affordable price.`,
        answer_ar:
          "تقدم مزيجًا رائعًا من الأناقة والكفاءة، مع 7 برامج غسيل تناسب مختلف الاحتياجات والتفضيلات، كل ذلك مع الحفاظ على سعر معقول.",
      },
    ],
    products: Washer2,
    image_url: "/imgs/top-ten/w_4_en.jpg",
    image_ar_url: "/imgs/top-ten/w_4_ar.jpg",
  },
  {
    "title-en": "Best LG Dishwashers in Saudi Arabia",
    "title-ar": "أفضل غسالات الصحون الصغيرة",
    "description-en": `When it comes to quality and technology in the world of dishwashers, LG
    stands out as one of the leading options in the market. LG dishwashers
    offer a variety of models to meet different needs and preferences, whether
    you’re looking for a large capacity dishwasher or advanced features to
    simplify your washing process. Here are some of the best LG dishwasher
    models:`,
    "description-ar":
      "عندما يتعلق الأمر بالمساحات المحدودة أو الاحتياجات المنزلية الأقل، تصبح غساله صحون صغيره الخيار المثالي لتوفير كل من الفعالية والكفاءة دون الحاجة إلى استهلاك مساحة كبيرة. هذه الغسالات الصغيرة تجمع بين الأداء القوي والتصميم المدمج، ما يجعلها مثالية للشقق، المطابخ الصغيرة، أو للأشخاص الذين لا يحتاجون إلى غسل كميات كبيرة من الأواني يوميًا. إليك بعض من أفضل غسالات الصحون الصغيرة التي تتميز بالكفاءة والجودة:",
    q_a: [
      {
        question_en:
          "LG Dishwasher, 14 Place Settings, 9 Programs, White (DFB512FW)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23",
        answer_en: `This dishwasher offers a wide range of programs to suit all your needs, with
        an elegant white design that adds a touch of beauty to your kitchen.`,
        answer_ar:
          "يوفر هذا المكيف من جري تبريدًا فعالًا بقوة توفر تصميمًا أنيقًا باللون الفولاذي مع 7 برامج غسيل تلائم مختلف الاحتياجات والتفضيلات، مثالية لمن يبحثون عن جمع بين الأناقة والأداء في جهاز واحد.",
      },
      {
        question_en:
          "LG Dishwasher, 14 Place Settings, 10 Programs, Stainless Steel (DFB325HS)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج أبيض HMDW1207W23",
        answer_en: `With its sleek stainless steel design and 10 wash programs, this
        dishwasher provides flexibility and high performance in cleaning dishes and
        utensils.`,
        answer_ar:
          "مع قوة تبريد تصل إلى تقدم نفس المزايا والكفاءة كنظيرتها الاستيل لكن بتصميم كلاسيكي أبيض، مما يجعلها خيارًا مثاليًا للمطابخ ذات التصميمات التقليدية أو الحديثة.",
      },
      {
        question_en:
          "LG Dishwasher, 14 Place Settings, 10 Programs, Silver (DFB425FP)",
        question_ar: "غسالة صحون فريجدير 12 مكان 6 برامج ابيض FDFE12FFGCWD",
        answer_en: `Featuring advanced technologies and 10 wash programs, this model
        ensures effective cleaning for all types of dishes, with easy control and use.`,
        answer_ar:
          "تتميز بسهولة الاستخدام والتصميم المدمج، مع 6 برامج غسيل تضمن تنظيفًا فعالًا لجميع أنواع الأواني والصحون.",
      },
    ],
    products: Washer3,
    image_url: "/imgs/top-ten/w_6_en.jpg",
    image_ar_url: "/imgs/top-ten/w_5_ar.jpg",
  },
  {
    "title-en":
      "LG Dishwasher, 14 Place Settings, 9 Programs, Silver (DFB415FP)",
    "title-ar": "أفضل غسالات صحون ال جي",
    "description-en": `This model is efficient and multi-programmed, making it an excellent choice
    for easily achieving clean and shiny dishes. It focuses on effectiveness and
    program diversity, allowing for efficient cleaning of various types of dishes,
    ideal for families with a wide range of dishwashing needs.`,
    "description-ar":
      "عند الحديث عن الجودة والتكنولوجيا في عالم غسالات الصحون، تبرز علامة غساله صحون ال جي كواحدة من الخيارات الرائدة في السوق. تقدم غساله صحون ال جي مجموعة متنوعة من الموديلات التي تلبي مختلف الاحتياجات والتفضيلات، سواء كنت تبحث عن غسالة صحون بسعة كبيرة أو ترغب في الحصول على ميزات متطورة تسهل عليك عملية الغسيل. إليك بعض من أفضل موديلات غسالات الصحون من ال جي:",
    q_a: [
      {
        question_en:
          "LG Dishwasher, 14 Place Settings, 9 Programs, Silver (DFC532FP)",
        question_ar: "غسالة صحون LG سعة 14 قطعة ابيض 9 برامج DFB512FW",
        answer_en: `This dishwasher offers advanced and efficient cleaning technologies in a
        compact design suitable for various spaces. It is designed to fit kitchens
        with space constraints without compromising performance or capacity.
        Emphasizing modern cleaning technologies, this dishwasher provides
        innovative solutions for cleaning challenges, such as removing tough stains
        and achieving water and energy efficiency.`,
        answer_ar:
          "يقدم هذا المكيف من هام تبريدًا متميزًا بقوة  تقدم هذه الغسالة مجموعة واسعة من البرامج لتناسب جميع احتياجاتك، مع تصميم أنيق باللون الأبيض يضفي لمسة جمالية على مطبخك.",
      },
      {
        question_en:
          "LG dishwasher, 14-piece capacity, 10 programs, Steel DFB325HS",
        question_ar: "غسالة صحون LG سعة 14 قطعة 10 برامج استيل DFB325HS",
        answer_en: `With its sleek steel design and 10 wash programmes, this washing machine offers flexibility and high performance in cleaning dishes and utensils`,
        answer_ar:
          "بفضل تصميمها الفولاذي الأنيق و10 برامج غسيل، توفر هذه الغسالة مرونة وأداء عاليًا في تنظيف الصحون والأواني",
      },
      {
        question_en: "LG dishwasher, 14 pieces, 10 programs, silver DFB425FP",
        question_ar: "غسالة صحون LG سعة 14 قطعة 10 برامج فضى DFB425FP",
        answer_en: `It features advanced technologies and 10 washing programs that ensure effective cleaning of all types of utensils, with ease of control and use.`,
        answer_ar:
          " تمتاز بتقنيات متقدمة و10 برامج غسيل تضمن تنظيفًا فعّالًا لجميع أنواع الأواني، مع سهولة التحكم والاستخدام.",
      },
      {
        question_en: "LG dishwasher, silver, 14 place, 9 program, DFB415FP",
        question_ar: "غسالة صحون LG فضي 14 مكان 9 برنامج DFB415FP",
        answer_en: `It is distinguished by its effectiveness and multiple programs, which makes it an excellent choice for getting clean and shiny utensils with ease. This model focuses on efficiency and versatility in the programs offered, allowing for efficient cleaning of various types of utensils, and is ideal for families who use a wide range of pots and dishes in their daily lives.`,
        answer_ar:
          "تميز بكونها فعالة ومتعددة البرامج، مما يجعلها خياراً ممتازاً للحصول على أواني نظيفة ولامعة بكل سهولة. هذا الموديل يركز على الفعالية والتنوع في البرامج المقدمة، مما يسمح بتنظيف مختلف أنواع الأواني بكفاءة، وهو مثالي للعائلات التي تستخدم مجموعة واسعة من الأواني والصحون في حياتهم اليومية.",
      },
      {
        question_en: "LG dishwasher, silver, 14 place, 9 program, DFC532FP",
        question_ar: "غسالة صحون LG فضي 14 مكان 9 برنامج DFC532FP",
        answer_en: `It offers advanced and effective cleaning technologies in a compact design suitable for various spaces. This washing machine is designed to fit into space-constrained kitchens without sacrificing performance or load capacity. With a focus on modern cleaning technologies, this washing machine provides innovative solutions to cleaning challenges, such as removing tough stains and achieving water and energy efficiency.`,
        answer_ar:
          "تقدم تقنيات تنظيف متقدمة وفعالة في تصميم مدمج وملائم لمختلف المساحات. هذه الغسالة مصممة للتناسب مع المطابخ التي تعاني من قيود المساحة دون التضحية بالأداء أو سعة التحميل. مع التركيز على تقنيات التنظيف الحديثة، توفر هذه الغسالة حلولاً مبتكرة للتحديات التي تواجه عملية التنظيف، مثل إزالة البقع الصعبة وتحقيق الكفاءة في استهلاك الماء والطاقة.",
      },
    ],
    products: Washer4,
    image_url: "/imgs/top-ten/w_6_en.jpg",
    image_ar_url: "/imgs/top-ten/w_6_ar.jpg",
  },
  {
    "title-en": "Best Haam Dishwashers in Saudi Arabia",
    "title-ar": "أفضل غسالات صحون هام",
    "description-en": `The Haam brand is well-known in the home appliance market for offering
    high-quality products that combine efficient performance with modern
    design. Haam provides a variety of dishwashers to meet different needs and
    preferences, from large sizes suitable for big families to smaller sizes for
    limited spaces. Here are some of the best Haam dishwasher models:`,
    "description-ar":
      "علامة غساله صحون هام تعتبر من الأسماء المعروفة في سوق الأجهزة المنزلية، والتي تشتهر بتقديمها لمنتجات عالية الجودة تجمع بين الكفاءة في الأداء والتصميم العصري. توفر هام مجموعة متنوعة من غسالات الصحون التي تلبي مختلف الاحتياجات والتفضيلات، بدءًا من الأحجام الكبيرة المناسبة للأسر الكبيرة وصولاً إلى الأحجام الأصغر للمساحات المحدودة. إليكم بعض من أفضل موديلات غساله صحون هام:",
    q_a: [
      {
        question_en:
          "Haam Dishwasher, 3 Racks, Silver, 14 Place Settings, 8 Programs (HM14PSDW18)",
        question_ar: "غسالة صحون هام 3 ارفف فضي 14 مكان 8 برامج HM14PSDW18",
        answer_en: `This model features a large capacity, accommodating up to 14 place
        settings, and offers 8 wash programs to suit different types of dishes and
        levels of dirt.`,
        answer_ar:
          " تتميز بسعتها الكبيرة التي تتيح تحميل حتى 14 مجموعة من الأواني والصحون، إضافة إلى 8 برامج غسيل تناسب مختلف أنواع الأواني ومستويات الاتساخ.",
      },
      {
        question_en:
          "Haam Dishwasher, 3 Racks, White, 14 Place Settings, 8 Programs (HM14PWDW18)",
        question_ar: "غسالة صحون هام 3 ارفف أبيض 14 مكان 8 برامج HM14PWDW18",
        answer_en: `With the same specifications and features as the silver model, this white
        design fits well with both modern and traditional kitchen decor.`,
        answer_ar:
          "نفس المواصفات والمزايا كالموديل الفضي، لكن بتصميم أبيض يتناسب مع ديكورات المطابخ الحديثة والتقليدية على حد سواء.",
      },
      {
        question_en:
          "Haam Dishwasher, 12 Place Settings, 7 Programs, Stainless Steel (HMDW1207S23)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج استيل HMDW1207S23",
        answer_en: `Ideal for medium-sized families, this dishwasher has a capacity of 12 place
        settings and is equipped with 7 wash programs, making it a great choice for
        those seeking versatility and efficiency.`,
        answer_ar:
          " مثالية للأسر المتوسطة بسعة 12 مكانًا ومجهزة بـ 7 برامج غسيل، مما يجعلها خيارًا رائعًا لمن يبحث عن تنوع في الوظائف والكفاءة في الاستخدام.",
      },
      {
        question_en:
          "Haam Dishwasher, 12 Place Settings, 7 Programs, White (HMDW1207W23)",
        question_ar: "غسالة صحون هام 12 مكان 7 برامج أبيض HMDW1207W23",
        answer_en: `Offering the same excellent performance as its stainless steel counterpart,
        this white model provides an option for users who prefer white appliances
        in their kitchens.`,
        answer_ar:
          "تقدم نفس الأداء الرائع لنظيرتها باللون الاستيل لكن باللون الأبيض، موفرةً بذلك خيارًا للمستخدمين الذين يفضلون الأجهزة البيضاء في مطابخهم.",
      },
    ],
    products: Washer5,
    image_url: "/imgs/top-ten/w_7_en.jpg",
    image_ar_url: "/imgs/top-ten/w_7_ar.jpg",
  },
];

export const TopTenFAQ = [
  {
    "title-en": "What are the most common split air conditioner malfunctions?",
    "title-ar": "ما هي أشهر اعطال مكيف سبليت؟",
    "description-en": `The most common split air conditioner malfunctions include water leakage, ineffective
    cooling, unusual sounds, or the outdoor unit stopping working. These malfunctions are often
    caused by lack of unit maintenance, clogged filters with dirt, or problems with the electrical
    circuit. It is recommended to contact a specialist in split air conditioner maintenance to
    determine the problem and fix it.`,
    "description-ar":
      "أبرز اعطال مكيف سبليت تشمل تسرب المياه، عدم التبريد بشكل فعال، ظهور أصوات غير معتادة، أو توقف الوحدة الخارجية عن العمل. غالبًا ما تنجم هذه الأعطال عن نقص في صيانة الوحدة، انسداد الفلاتر بالأوساخ، أو مشاكل في الدائرة الكهربائية. يُنصح بالتواصل مع متخصص في صيانة مكيفات سبليت لتحديد المشكلة وإصلاحها.",
  },
  {
    "title-en": "What is the best silent split air conditioner?",
    "title-ar": "ما هو افضل مكيف سبليت بدون صوت؟",
    "description-en": `The best silent split air conditioner relies on noise reduction technologies such as silent
    compressors and quiet fan designs. Brands like LG and Samsung offer air conditioners
    equipped with inverter technology to ensure quiet operation.`,
    "description-ar":
      "افضل مكيف سبليت بدون صوت يعتمد على تقنيات تخفيض الضجيج مثل الضواغط الصامتة وتصاميم المروحة الهادئة. علامات تجارية مثل LG و Samsung تقدم مكيفات مزودة بتكنولوجيا الانفرتر لضمان تشغيل هادئ.",
  },
  {
    "title-en": "How are split air conditioners maintained?",
    "title-ar": "كيف تتم صيانة مكيفات سبليت؟",
    "description-en": `Maintenance of split air conditioners includes inspecting the internal and external units,
    cleaning the filters, checking the integrity of the electrical parts, and filling the refrigerant gas
    if necessary. It is preferable to perform periodic maintenance annually to maintain optimal
    performance.`,
    "description-ar":
      "صيانة مكيفات سبليت تشمل فحص الوحدات الداخلية والخارجية، تنظيف الفلاتر، التحقق من سلامة الأجزاء الكهربائية، وتعبئة غاز التبريد إذا لزم الأمر، ويُفضل إجراء صيانة دورية سنويًا للحفاظ على الأداء الأمثل.",
  },
  {
    "title-en": "What are the latest split air conditioner offers?",
    "title-ar": "ما هي أحدث عروض مكيفات سبليت؟",
    "description-en": `<a href="https://www.almanea.sa/air-conditioners-c-535/split-acs-c-539" target="_blank" style="color: blue; text-decoration: underline;">Split air conditioner </a> offers are constantly changing and are usually available at the beginning
    of the summer season or during promotional events in Almanea, and include price discounts,
    free installation service, or extended warranties.`,
    "description-ar": `عروض <a href="https://www.almanea.sa/air-conditioners-c-535/split-acs-c-539" target="_blank" style="color: blue; text-decoration: underline;">مكيفات سبليت</a> تتغير باستمرار وتتوفر عادة في بداية موسم الصيف أو خلال المناسبات الترويجية في المنيع، وتشمل خصومات على الأسعار، خدمة تركيب مجانية، أو ضمانات ممددة.`,
  },
  {
    "title-en": "What is the importance of washing split air conditioners?",
    "title-ar": "ما أهمية غسيل مكيفات سبليت؟",
    "description-en": `Washing split air conditioners is necessary to remove accumulated dust and dirt that can
    negatively affect the cooling efficiency and air quality inside the room. It is recommended to
    wash the filters periodically and hire experts to thoroughly clean the unit to maintain the
    device’s performance and extend its lifespan. Cleaning split air conditioners regularly also
    helps reduce energy consumption and avoid health problems associated with poor air
    quality.`,
    "description-ar":
      "غسيل مكيفات سبليت ضروري لإزالة الغبار والأوساخ المتراكمة التي يمكن أن تؤثر سلبًا على كفاءة التبريد وجودة الهواء داخل الغرفة. يُنصح بغسيل الفلاتر بشكل دوري والاستعانة بخبراء لتنظيف الوحدة بشكل شامل للحفاظ على أداء الجهاز وإطالة عمره الافتراضي. تنظيف مكيفات سبليت بشكل منتظم يساعد أيضًا في تقليل استهلاك الطاقة وتجنب المشاكل الصحية المرتبطة بجودة الهواء السيئة.",
  },
  {
    "title-en": "What is Tabby split air conditioner?",
    "title-ar": "ما هو مكيف سبليت تابي؟",
    "description-en": `Tabby Split Air Conditioner refers to portable split air conditioners that are easy to install and
    transport and are ideal for people who need flexible and moveable cooling solutions. In
    addition, some stores, such as Almanea, offer split air conditioners in installments, which
    makes it easier to purchase these types of air conditioners with easy payment terms, in
    order to provide convenient purchasing options that suit various needs and budgets.`,
    "description-ar":
      "مكيف سبليت تابي يشير إلى مكيفات السبليت المحمولة التي تتميز بسهولة التثبيت والنقل، وهي مثالية للأشخاص الذين يحتاجون إلى حلول تبريد مرنة وقابلة للتحريك. بالإضافة إلى ذلك، بعض المتاجر مثل المنيع تقدم مكيفات سبليت اقساط، مما يسهل شراء هذه الأنواع من المكيفات بشروط دفع ميسرة، وذلك لتوفير خيارات شراء مريحة تتناسب مع مختلف الاحتياجات والميزانيات",
  },
  {
    "title-en": "What are the advantages of a small split air conditioner?",
    "title-ar": "ما هي مميزات المكيف سبليت صغير؟",
    "description-en": `The mini split air conditioner provides an ideal solution for small spaces, such as small
    rooms or offices, thanks to its compact size and high cooling efficiency, with lower energy
    consumption compared to larger models.`,
    "description-ar": `المكيف السبليت الصغير يوفر حلاً مثاليًا للمساحات الصغيرة، مثل الغرف الصغيرة أو المكاتب، بفضل حجمه المدمج وكفاءته العالية في التبريد، مع استهلاك طاقة أقل مقارنة بالموديلات الأكبر.`,
  },
];

export const TopTenDishWasherFAQ = [
  {
    "title-en": "What are common dishwasher malfunctions?",
    "title-ar": "ما هي اعطال غسالة صحون؟",
    "description-en": `Common dishwasher malfunctions include drainage issues, insufficient
    cleaning of dishes, water leaks, and control panel failures. These problems
    are often caused by clogged filters, using improper detergents, or electrical
    connection issues.`,
    "description-ar":
      "الأعطال الشائعة لغسالة الصحون تشمل مشاكل في التصريف، عدم تنظيف الأواني بشكل كافٍ، تسريب المياه، أو أعطال في لوحة التحكم. غالبًا ما تكون هذه المشاكل ناتجة عن انسداد الفلتر، استخدام منظف غير مناسب، أو مشكلة في التوصيلات الكهربائية.",
  },
  {
    "title-en": "How is dishwasher maintenance performed?",
    "title-ar": ` كيف تتم صيانة غسالة صحون؟`,
    "description-en": `Dishwasher maintenance involves regularly cleaning the filters, ensuring
    the spray arms are clear and unobstructed, and using detergents
    specifically designed for dishwashers. It’s also recommended to run an
    empty cleaning cycle occasionally, Using a special dishwasher cleaner to
    remove grease and limescale buildup.`,
    "description-ar":
      "صيانة غسالة صحون تتم عبر تنظيف الفلاتر بانتظام، التأكد من سلامة الأذرع الرشاشة وعدم انسدادها، واستخدام منظفات خاصة بغسالات الصحون. يُنصح أيضًا بتشغيل دورة تنظيف غساله صحون فارغة بين الحين والآخر باستخدام منظف خاص لإزالة تراكم الدهون والجير.",
  },
  {
    "title-en": "What are the latest dishwasher deals?",
    "title-ar": "ما هي آخر عروض غسالة صحون؟",
    "description-en": `To find the latest dishwasher deals, it’s advisable to visit <a target="_blank" href="https://www.almanea.sa/home-appliances-c-7364/dishwashers-c-7338" style="color:blue; text-decoration: underline;">Almanea’s website</a>
    or subscribe to their newsletters to receive the latest updates on discounts
    and promotional offers.`,
    "description-ar": `لمعرفة آخر عروض غسالة صحون، يُنصح بزيارة <a target="_blank" href="https://www.almanea.sa/home-appliances-c-7364/dishwashers-c-7338" style="color:blue; text-decoration: underline;">مواقع المنيع</a> أو الاشتراك في النشرات البريدية للحصول على التحديثات الأخيرة حول الخصومات والعروض الترويجية.`,
  },
  {
    "title-en": "Do dishwashers need cleaning?",
    "title-ar": "هل نحتاج إلى غسيل غسالة صحون؟",
    "description-en": `Yes, cleaning your dishwasher is essential to maintain its efficiency and
    extend its lifespan. It’s recommended to run an empty cleaning cycle with a
    special cleaner every month to remove limescale and food residue buildup.`,
    "description-ar": `نعم، تنظيف غساله صحون ضروري للحفاظ على كفاءتها وطول عمرها الافتراضي. يُنصح بتشغيل دورة تنظيف فارغة باستخدام منظف خاص كل شهر للتخلص من تراكم الجير وبقايا الطعام.`,
  },
  {
    "title-en": "What is a portable dishwasher?",
    "title-ar": "ما هي غسالة صحون تابي؟",
    "description-en": `A portable dishwasher refers to compact or portable dishwashers that are
    easy to move and install. They are an excellent option for small spaces or
    for those who do not want a permanent dishwasher installation. Portable
    dishwashers offer flexibility in usage and storage.`,
    "description-ar": `غسالة صحون تابي تشير إلى الغسالات المحمولة أو المدمجة التي تتميز بسهولة الحركة والتركيب. هي خيار ممتاز للمساحات الصغيرة أو لمن لا يرغبون في تثبيت غسالة صحون دائمة. توفر مكيفات غساله صحون المرونة في الاستخدام والتخزين.`,
  },
];

export const TopTenSeo = {
  air_condition: {
    title_en: "Top Split Air Conditioners in Saudi Arabia | Almanea",
    description_en:
      "Explore the best split air conditioners based on their cooling power and brands and find information to help you choose the right AC for you.",
    title_ar: "أفضل مكيفات سبليت في السعودية | المنيع",
    description_ar:
      "تعرف على أفضل أنواع مكيفات السبليت بناءَ على قوة التكييف والعلامة التجارية. في هذا المقال نوفر لك معلومات تساعدك على إختيار المكيف المناسب لك.",
  },
  dish_washer: {
    title_en: "Best Dishwashers And How To Use Them | Almanea",
    description_en:
      "Explore the best dishwashers, how to choose one, and how to use it. The article provides detailed info as well as links to purchase selected washing machines.",
    title_ar: "أفضل غسالات الصحون وطريقة إستخدامهم | المنيع",
    description_ar:
      "تعرفوا في هذا المقال على أفضل أنواع غسالات الصحون، كيفية اختيارها، وطريقة استخدامها. يوفر المقال معلومات مفصلة بالاضافة الى روابط شراء الغسالات المختارة.",
  },
};
